import { UseQueryResult } from '@tanstack/react-query'
import { useMemo } from 'react'
import { z } from 'zod'

import * as api from '../api'
import { useApiQuery } from '../useApiQuery'

const TYPE_FILTERS = [
  { name: 'online_class', id: 'online_class' },
  { name: 'hybrid', id: 'hybrid' },
  { name: 'live_training', id: 'live_training' },
  { name: 'webinar', id: 'webinar' },
  { name: 'learning_path', id: 'learning_path' },
]

const learningItemFilterOptionsParser = z.array(z.object({ uuid: z.string(), name: z.string() }))

export type FilterOptions = z.infer<typeof learningItemFilterOptionsParser>

const learningItemFilterOptionsDummy = [...Array(5).keys()].map((i) => ({ uuid: String(i), name: 'Lorem Ipsum' }))

export default function useLearningItemFilterOptions() {
  const result: UseQueryResult<FilterOptions> = useApiQuery({
    queryKey: ['learningItemFilterOptions'],
    placeholderData: (previousData) => previousData || learningItemFilterOptionsDummy,
    queryFn: async () => learningItemFilterOptionsParser.parse((await api.get('category?page=1&page_size=1000')).data),
  })

  return useMemo(
    () => ({
      category: result.data || [],
      type: TYPE_FILTERS,
      isPending: result.isPending,
      isPlaceholderData: result.isPlaceholderData,
    }),
    [result.data, result.isPending, result.isPlaceholderData]
  )
}
